import { NO_ALCOHOL_STORES } from "@/utils/constant";

export const getAlcoholStoreFilter = (
  storeID: string | undefined,
  storeRegion: string| undefined,
  brand?:string|null
) => {
  const isNoAlcoholStore = NO_ALCOHOL_STORES.some(
    (store) => store == storeRegion
  );
  const alcoholFilter = isNoAlcoholStore
    ? `storeId:${storeID} AND allergens.alcohol:false AND isVisible:true AND isMassOffers:false`
    : `storeId:${storeID} AND isVisible:true AND isMassOffers:false`;

    const filters = brand
    ? `${alcoholFilter} AND brand:"${brand}"`
    : alcoholFilter;

  return filters;
};
